var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"tab"},[_c('li',{class:{ 'active' : _vm.currentIndex === 0 },on:{"click":function($event){return _vm.changeIndex(0)}}},[_vm._v("导游注册")]),_c('li',{class:{ 'active' : _vm.currentIndex === 1 },on:{"click":function($event){return _vm.changeIndex(1)}}},[_vm._v("单位注册")])])
}
var staticRenderFns = []

export { render, staticRenderFns }